import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * Full-screen mobile wrapper for reused desktop pages (editors, settings,
 * lists). Gives a fixed back-bar + scrollable content. No bottom nav — these
 * are pushed screens reached from a tab/detail; back returns to where you were.
 */
export const MobileScreen = ({ title, children }) => {
  const navigate = useNavigate();
  return (
    <div className="fixed inset-0 bg-[#F8F9FA] flex flex-col" data-testid="m-screen">
      <header className="h-[52px] bg-white border-b border-[#E5E7EB] flex items-center gap-2 px-2 shrink-0">
        <button type="button" onClick={() => navigate(-1)} data-testid="m-screen-back" aria-label="Back" className="w-11 h-11 flex items-center justify-center text-[#111827]">
          <ArrowLeft className="h-5 w-5" />
        </button>
        {title && <p className="text-[15px] font-semibold text-[#111827] truncate">{title}</p>}
      </header>
      <div className="flex-1 overflow-y-auto px-4 py-4" style={{ paddingBottom: 'calc(24px + env(safe-area-inset-bottom))' }}>
        {children}
      </div>
    </div>
  );
};

export default MobileScreen;
